import { boolean, foreignKey, pgTable, text, uuid } from 'drizzle-orm/pg-core';
import { MetricType, RecordType } from '../../enums';
import { isoTimestamp, sortOrder } from '../../utils';
import { orgPrimaryKey, orgTableBase } from '../org-id';
import { Tag } from '../tag';
import { configColumn, metricConfigDefaults } from '../../json';
export const ExerciseMetric = pgTable('exercise_metric', {
    ...orgTableBase,
    sortOrder,
    name: text('name').notNull(),
    type: MetricType('type').notNull(),
    isCollectable: boolean('is_collectable').notNull().default(true),
    isDefault: boolean('is_default').notNull().default(false),
    config: configColumn('config', metricConfigDefaults).notNull(),
    categoryId: uuid('category_id'),
    deletedAt: isoTimestamp('deleted_at'),
    recordType: RecordType('record_type'),
}, (table) => ({
    pk: orgPrimaryKey(table),
    categoryFk: foreignKey({
        columns: [table.orgId, table.categoryId],
        foreignColumns: [Tag.orgId, Tag.id],
    }),
}));
//# sourceMappingURL=index.js.map